import { capitalize } from '@as-react/common-utils';
const defaultPaddingsMap = {
    none: 0,
    xs: 1,
    sm: 2,
    md: 3,
    lg: 4,
    gutter: 2,
};
export const getBoxPropsFromAEMPaddings = (paddings = {}, map = defaultPaddingsMap) => {
    const paddingDirections = Object.keys(paddings);
    return Object.values(paddings).reduce((prevValue, curValue, index) => {
        if (!curValue) {
            return prevValue;
        }
        const direction = paddingDirections[index];
        return {
            mobile: Object.assign(Object.assign({}, prevValue.mobile), { spacing: Object.assign(Object.assign({}, prevValue.mobile.spacing), { [`padding${capitalize(direction)}`]: map[curValue] }) }),
        };
    }, { mobile: { spacing: {} } });
};
